module.exports = __webpack_public_path__ + "img/408.dd51cf77.jpg";